import { PaymentPdfDto } from "../office/interfaces/payment_pdf_dto";
import { TwoDecimal } from "./TwoDecimal";

export function ConvertToInvoicePdfDto(invoice) {
    const filteredPayments = invoice.payments.filter(payment => payment.payment > 0);
    const filteredInvoiceItems = invoice.invoice_items.filter(item => item.prize !== null);

    return {
        logo_url: invoice.customer.logo_url,
        logo_alignment: invoice.customer.logo_alignment,
        creditor: {
            brand: invoice.customer.brand,
            name: invoice.customer.forename + " " + invoice.customer.surname,
            address: invoice.customer.street,
            zip: invoice.customer.postal_code,
            city: invoice.customer.city,
            account: invoice.customer.iban,
            country: "CH"
        },
        debtor: {
            name: invoice.student_id.forename + " " + invoice.student_id.surname,
            address: invoice.student_id.street,
            zip: invoice.student_id.postal_code,
            city: invoice.student_id.city,
            country: "CH"
        },
        invoice_date: invoice.date,
        items: filteredInvoiceItems.map((item, index) => {
            return {
                position: (index + 1).toString(),
                datum: new Date(item.date).toLocaleDateString("fr-CH"),
                anzahl: item.amount.toString(),
                einheit: item.unit,
                bezeichnung: item.name,
                einheitspreis: TwoDecimal(item.initial_prize / item.amount).toString(),
                beschreibung: item.description || "",
                total: TwoDecimal(item.prize).toString()
            };
        }),
        payments: filteredPayments.map((payment) => {
            return {
                amount: payment.payment,
                payment_method: payment.payment_method,
                date: payment.date
            };
        }),
        amount: invoice.amount,
        rechnungTotal: invoice.total_amount,
        currency: "CHF",
        logo: ""
    }
}

export function ConvertToPaymentPdfDto(payment) {
    return {
        logo_url: payment.customer.logo_url,
        logo_alignment: payment.customer.logo_alignment,
        creditor: {
            brand: payment.customer.brand,
            name: payment.customer.forename + " " + payment.customer.surname,
            address: payment.customer.street,
            zip: payment.customer.postal_code,
            city: payment.customer.city,
            account: payment.customer.iban,
            country: "CH"
        },
        debtor: {
            name: payment.student_id.forename + " " + payment.student_id.surname,
            address: payment.student_id.street,
            zip: payment.student_id.postal_code,
            city: payment.student_id.city,
            country: "CH"
        },
        date: payment.date,
        amount: payment.amount,
        payment_currency: "CHF",
        payment_method: payment.payment_method,
        currency: "CHF",
    } as PaymentPdfDto
}
